<template>
    <div class="DocumentMyBox">
        <doc-page ref='docPage' :moduleCode='moduleCode' :rootFolderId="rootFolderId" :rootFolderName="rootFolderName" :folderSource="folderSource" class="DocumentMy"></doc-page>
    </div>
</template>

<script>
import DocPage from '../Vue/DocPage/index'
import titleMixin from '@/mixin/title'
export default {
    name: 'MyDocument',
    mixins: [titleMixin],
    title: function fc() { return this.$t('mx_mobile.App.1584682646398') }, // '我的文档'
    data() {
        return {
            moduleCode: 'DC002',
            rootFolderId: 2,
            rootFolderName: this.$t('mx_mobile.App.1584682646398'), // '我的文档'
            folderSource: 2
        }
    },
    created() { },
    mounted() { },
    methods: {},
    beforeRouteLeave(to, from, next) {
        this.$refs.docPage.beforeLeave(to, from, next)
    },
    watch: {
        $route(to, from) {
            if (this.$route.path == '/document/mydocument') {
                this.$refs.docPage.setMenu()
                this.$refs.docPage.reGetList()
            }
        }
    },
    components: {
        'doc-page': DocPage
    }
}
</script>

<style lang='less' rel='stylesheet/less' scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
